var map = {
	"./bg-img-0-dark.png": "1660",
	"./bg-img-0.png": "7375",
	"./bg-img-1-dark.png": "710e",
	"./bg-img-1.png": "bc6a",
	"./bg-img-2-dark.png": "5cb2",
	"./bg-img-2.png": "7944",
	"./bg-img-3-dark.png": "6a4d",
	"./bg-img-3-mask.png": "3908",
	"./bg-img-3.png": "c2d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "be59";